import React from 'react';
import bioText from './bioText';

function BioParagraph() {
    return (
        <p className="bio-paragraph">{bioText}</p>
    );
}

export default BioParagraph;